import { SearchBar as UISearchBar } from "@webmotors/eleanor-ui";
import type { SearchBarProps as  UISearchBarProps } from "@webmotors/eleanor-ui/webmotors/search-bar";

export function SearchBar(props: Readonly<SearchBarProps>) {
  return <UISearchBar {...props} data-testid="bottom-sheet" />;
}

export type SearchBarProps = UISearchBarProps;
